import React, { CSSProperties } from 'react';
import { reactUrlToBrowserUrl } from '../../../../urlParse';
import Basepage, { BasePageState } from '../Basepage';
import BestsellerViewer from '../Basepage/parts/BestsellerViewer';
import MolLink from '../Basepage/parts/Menu/MolLink';
import ProductCarousel from '../Basepage/parts/ProductCarousel';
import { ProductCarouselModel } from '../Basepage/parts/ProductCarousel/Model';

import './index.scss';
import { CSSInjection } from './overrides';

import themenImgKinder from './Parts/images/Kinder grau.svg';
import themenImgNatur from './Parts/images/Natur grau.svg';
import themenImgReise from './Parts/images/Reise grau.svg';
import themenImgTiere from './Parts/images/Tiere grau.svg';
import themenImgKunst from './Parts/images/Kunst grau.svg';
import themenImgFilm from './Parts/images/Film grau.svg';
import themenImgHumor from './Parts/images/Humor grau.svg';
import themenImgWissen from './Parts/images/Wissen grau.svg';

//Tiere

import Banner from './Parts/Banner';

interface StartPageState extends BasePageState {}

interface StartPageModel {
  bannerConfig: any;
  features: any;
  features_1: any;
  features_2: any;
  spiegel_HCBelle: ProductCarouselModel[];
  spiegel_HoerbuchKinder: ProductCarouselModel[];
}

interface ImageTableParts {
  imagePart: JSX.Element;
  labelPart: JSX.Element;
}

export default class StartPage extends Basepage<
  StartPageState,
  StartPageModel
> {
  renderChild(): JSX.Element {
    let kalenderlieblingCSS = CSSInjection();

    // Kalenderjahr vom PHP-Shop (ApiBase::GetKalenderJahr, Wechsel am 01.06.)
    const kalenderJahr: number = this.state?.apiData?.kalenderJahr;

    let styleAngebot: CSSProperties = { height: '100px' };

    let craeateTableElement = (input: {
      to: string;
      href: string;
      imageLink: string;
      caption: string;
    }): ImageTableParts => {
      let imagePart = (
        <MolLink to={input.to} href={input.href}>
          <img
            src={input.imageLink}
            alt={input.caption}
            title={input.caption}
          />
        </MolLink>
      );
      let captionPart = (
        <MolLink to={input.to} href={input.href}>
          {input.caption}
        </MolLink>
      );

      return { imagePart: imagePart, labelPart: captionPart };
    };

    let createImageTable = (elements: ImageTableParts[]) => {
      return (
        <table>
          <tbody>
            <tr>
              {elements.map((item, index) => {
                let key = 'td_image_' + index;
                return (
                  <td id={key} key={key}>
                    {item.imagePart}
                  </td>
                );
              })}
            </tr>
            <tr>
              {elements.map((item, index) => {
                let key = 'td_label_' + index;
                return (
                  <td id={key} key={key}>
                    {item.labelPart}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      );
    };

    return (
      <div id="startPage">
        <Banner
          config={this.body.bannerConfig}
          showRows={true}
          showDots={true}
        />
        <div id="caruselWraper">
          <ProductCarousel
            items={this.body.features}
            title="Neuheiten"
            titlePosition="center"
            showTitle={true}
            titleLink={
              '/search_page/?fqZZZAktion=athesia%20neuheiten%20' + kalenderJahr
            }
          ></ProductCarousel>
        </div>

        <div className="KalenderlieblingParent">
          <div className="productCarousel">
            <div className="productCarouselTitel center">Unsere Empfehlung</div>
          </div>

          <style>{kalenderlieblingCSS}</style>
          <MolLink
            to="/product_info/2995155101"
            href="/kalender/2995155101-food+gallery+kalender+2027/"
          >
            <div className="Kalenderliebling"></div>
          </MolLink>
        </div>

        <div id="caruselWraper">
          <div className="productCarousel">
            <div className="productCarouselTitel center">Themen</div>
          </div>
          <div id="themenDiv">
            {createImageTable([
              craeateTableElement({
                to: `/search_page/?fqZZZListe=Athesia+Edition+${kalenderJahr}&keyword=kinder`,
                href: `Liste/Athesia+Edition+${kalenderJahr}/s/?keyword=kinder`,
                imageLink: themenImgKinder,
                caption: 'Kinder',
              }),
              craeateTableElement({
                to: `/search_page/?fqZZZListe=Athesia+Edition+${kalenderJahr}&keyword=natur`,
                href: `Liste/Athesia+Edition+${kalenderJahr}/s/?keyword=natur`,
                imageLink: themenImgNatur,
                caption: 'Natur',
              }),
              craeateTableElement({
                to: `/search_page/?fqZZZListe=Athesia+Edition+${kalenderJahr}&keyword=reise`,
                href: `Liste/Athesia+Edition+${kalenderJahr}/s/?keyword=reise`,
                imageLink: themenImgReise,
                caption: 'Reise',
              }),
              craeateTableElement({
                to: `/search_page/?fqZZZListe=Athesia+Edition+${kalenderJahr}&keyword=tier`,
                href: `Liste/Athesia+Edition+${kalenderJahr}/s/?keyword=tier`,
                imageLink: themenImgTiere,
                caption: 'Tiere',
              }),
              craeateTableElement({
                to: `/search_page/?fqZZZListe=Athesia+Edition+${kalenderJahr}&keyword=kunst`,
                href: `Liste/Athesia+Edition+${kalenderJahr}/s/?keyword=kunst`,
                imageLink: themenImgKunst,
                caption: 'Kunst',
              }),
              craeateTableElement({
                to: `/search_page/?fqZZZListe=Athesia+Edition+${kalenderJahr}&keyword=film`,
                href: `Liste/Athesia+Edition+${kalenderJahr}/s/?keyword=film`,
                imageLink: themenImgFilm,
                caption: 'Film',
              }),
              craeateTableElement({
                to: `/search_page/?fqZZZListe=Athesia+Edition+${kalenderJahr}&keyword=humor`,
                href: `Liste/Athesia+Edition+${kalenderJahr}/s/?keyword=humor`,
                imageLink: themenImgHumor,
                caption: 'Humor',
              }),
              craeateTableElement({
                to: `/search_page/?fqZZZListe=Athesia+Edition+${kalenderJahr}&keyword=wissen`,
                href: `Liste/Athesia+Edition+${kalenderJahr}/s/?keyword=wissen`,
                imageLink: themenImgWissen,
                caption: 'Wissen',
              }),
            ])}
          </div>
        </div>

        <br className="clearBoth" />
        {/* 
        <div id="caruselWraper">
          <ProductCarousel
            items={this.body.features_1}
            title="Familienplaner"
            titlePosition="center"
            titleLink="/search_page/?fqZZZAthesia=Familienplaner"
            showTitle={true}
          ></ProductCarousel>
        </div>

        <div id="caruselWraper">
          <ProductCarousel
            items={this.body.features_2}
            title="Kalenderbücher"
            titlePosition="center"
            titleLink="/search_page/?fqZZZAthesia=Kalenderbücher"
            showTitle={true}
          ></ProductCarousel>
        </div>
      */}
      </div>
    );
  }

  buildListBoxItem(reactLink: string, icon: any, text: string) {
    let broserLink = reactUrlToBrowserUrl(reactLink, null, null);
    return (
      <div className="link-box">
        <div className="flex-bild">
          <MolLink to={reactLink} href={broserLink}>
            <img alt={text} src={icon} />
          </MolLink>
        </div>
        <div className="flex-link">
          <MolLink to={reactLink} href={broserLink}>
            {text}
          </MolLink>
        </div>
      </div>
    );
  }

  initState(base: BasePageState): StartPageState {
    let newState: StartPageState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(): string {
    return this.state.apiBase + '/index.php?frame=api&main_page=start';
  }
  childDidMount(): void {}
  childDidUnmount(): void {}

  initJSChild(): string {
    let initjs = '';

    return initjs;
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return null;
  }

  pageHeaderGetter(): string {
    return '';
  }
  pageTitleGetter(): string {
    return '';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Startpage</span>;
  }
  getType(): string {
    return 'StartPage';
  }
}
